import { createProvider } from "../../vue-apollo";
import store from "../../store";

let apolloProvider = createProvider();

import gql from "graphql-tag";
import { FRAGMENT_USER_ALL_FIELDS } from "../../graphql/gqlFragments";

export default function userExist() {
  if (localStorage.getItem("AUTH_TOKEN")) {
    apolloProvider.defaultClient
      .query({
        query: gql`
          {
            getUser {
              ...UserAllFields
            }
          }
          ${FRAGMENT_USER_ALL_FIELDS}
        `
      })
      .then(res => {
        store.dispatch("initUser", res.data.getUser);
      })
      .catch(() => {
        store.dispatch("destroyUser");
      });
  }
}
